import Helper from "@ember/component/helper";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import type Patient from "parog-web/models/patient";
import type SemeiaSessionService from "parog-web/services/session";

export function route(
  sourceJeId: string | undefined,
  asModal = false,
  session: SemeiaSessionService
) {
  let route;

  if (session.medic) {
    if (asModal) {
      route =
        "medics-web.protected.patients.patient.dashboard.main.feature.component";
    } else {
      route = "medics-web.protected.patients.patient.feature.component";
    }
  } else if (session.patient) {
    route = "patient-web.protected.feature.component";
  } else {
    return;
  }

  if (sourceJeId) {
    route += ".edition";
  }

  return route;
}

export function models(
  feature: string,
  component: string,
  patient,
  sourceJeId,
  session: SemeiaSessionService
) {
  if (session.patient) {
    return sourceJeId ? [feature, component, sourceJeId] : [feature, component];
  }

  return sourceJeId
    ? [patient, feature, component, sourceJeId]
    : [patient, feature, component];
}

interface Signature {
  Args: {
    Positional: [feature: string, component: string];
    Named: {
      patient: Patient;
      /** The ID of an existing JE */
      sourceJeId?: string;
    };
  };
  Return: () => void;
}

/**
 * An helper to directly transition to a forc from a template.
 * @example
 * onClick={{transition-to-forc 'weight' 'edition-form"
 *   @patient someJe.id true}}
 */
export default class TransitionToForc extends Helper<Signature> {
  @service declare router: RouterService;
  @service declare session: SemeiaSessionService;

  override compute([feature, component], { patient, ...queryParams }) {
    return () => {
      if (!this.session.medic && !this.session.patient) {
        throw new Error("unknown user type, cannot transition");
      }

      this.router.transitionTo(
        route(queryParams.sourceJeId, queryParams.asModal, this.session),
        ...this.params(feature, component, patient, queryParams)
      );
    };
  }

  params(feature, component, patient, queryParams) {
    const params = models(
      feature,
      component,
      patient,
      queryParams.sourceJeId,
      this.session
    );

    params.push({ queryParams });
    return params;
  }
}
